
























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { ILocale } from "@/@types/locale";
import { IReason } from "@/@types/orders/reason";

import UploadingImageToServer from "@/components/app/images/uploading-image-to-server.vue";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import CloseButton from "@/components/buttons/close-button.vue";
import StandartModal from "@/components/app/standart-modal.vue";
import BSwitch from "../../app/switchs/b-switch.vue";

@Component({
  mixins: [validationMixin],
  validations: {
    name: { required },
  },
  components: {
    StandartModal,
    BSwitch,
    CloseButton,
    UploadingImageToServer,
    submit: SubmitResetButtonGroop,
  },
})
export default class OrderReasonForm extends Vue {
  @Prop({ type: Object, default: null }) item!: IReason;

  activeLocale = this.$store.getters.getLanguages[0];

  get languages(): Array<string> {
    return this.$store.getters.getLanguages;
  }

  name = "";
  names: ILocale = {};
  show = true;

  get reason(): IReason {
    return {
      _id: this.item ? this.item._id : "",
      name: this.names,
      show: this.show,
    };
  }

  @Watch("name")
  entryFolderName(): void {
    this.names[this.activeLocale] = this.name;
  }

  @Watch("activeLocale")
  folderName(): void {
    if (this.names)
      this.name = this.names[this.activeLocale]
        ? this.names[this.activeLocale]
        : "";
    else this.name = "";
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }

    this.$emit("sendReason", this.reason);
  }

  onReset(): void {
    this.name = "";
    this.names = {};
    this.activeLocale = this.languages[0];
    this.show = false;
  }

  @Watch("item")
  autoFillingForm(): void {
    if (!this.item) return;
    this.names = this.item.name;
    this.show = this.item.show;
    this.folderName();
  }

  mounted(): void {
    this.autoFillingForm();
  }
}
